var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-card',{staticClass:"wiwi p-0 m-0"},[_c('b-card-body',{staticClass:"p-0 m-0"},[_c('untabbedQuestion',{attrs:{"tabName":_vm.currentTab,"changeQuestion":_vm.changeQuestion},on:{"keysubmit":function($event){return _vm.$emit('keysubmitnow')},"opencalc":function($event){return _vm.$emit('opencalcnow')}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }